import { render } from "./checkoutDetails.vue?vue&type=template&id=2d5a4978"
import script from "./checkoutDetails.vue?vue&type=script&lang=js"
export * from "./checkoutDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__